// Same dev-only gate as isJsonViewerEnabled.js - a living catalogue of the
// shared _components/ui library (with real, interactive examples) is a
// build-time reference for whoever's touching the frontend, not something a
// customer-facing deployment should ever expose. The one deployed exception
// is the demo environment (exact host below), which is our internal testing
// site; it is a production build, so the NODE_ENV check alone would hide it.
export const DEMO_HOSTNAME = "demo.kribana.com";

export function isComponentLibraryEnabled() {
  const isDev = process.env.NODE_ENV === "development";
  const isNotProduction =
    process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" &&
    process.env.REACT_APP_SERVER !== "PRODUCTION";
  const isLocalhost = window.location.hostname === "localhost";
  const isDevHost =
    window.location.hostname.includes("dev") ||
    window.location.hostname.includes("staging") ||
    window.location.hostname.includes("127.0.0.1");

  const isDemoHost = window.location.hostname === DEMO_HOSTNAME;

  return isNotProduction && ((isDev && (isLocalhost || isDevHost)) || isDemoHost);
}
